import React, { useState } from 'react'
import { useAuth } from '../lib/AuthContext'

export default function LoginPage() {
  const { signIn } = useAuth()
  const [email, setEmail]       = useState('')
  const [password, setPassword] = useState('')
  const [error, setError]       = useState('')
  const [loading, setLoading]   = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    setLoading(true)
    try {
      await signIn(email.trim().toLowerCase(), password)
    } catch (err) {
      setError('Email atau password salah. Coba lagi.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div style={{
      minHeight: '100vh', background: '#f5f5f3',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem',
    }}>
      <div style={{ width: '100%', maxWidth: 380 }}>

        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <img
            src="/Logo ICS Hi-Ress.png"
            alt="ICS Compute"
            style={{ height: 56, objectFit: 'contain', marginBottom: '1.25rem' }}
          />
          <div style={{ fontSize: 20, fontWeight: 700, color: '#111' }}>Telesales Tracker</div>
          <div style={{ fontSize: 13, color: '#888', marginTop: 4 }}>Masuk untuk melanjutkan</div>
        </div>

        {/* Form */}
        <div style={{
          background: '#fff', borderRadius: 14,
          border: '0.5px solid rgba(0,0,0,0.1)',
          padding: '1.75rem',
          boxShadow: '0 2px 16px rgba(0,0,0,0.06)',
        }}>
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: '1rem' }}>
              <label style={{ fontSize: 12, fontWeight: 600, color: '#555', display: 'block', marginBottom: 5 }}>
                Email
              </label>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="nama@icscompute.com"
                required
                autoFocus
                style={{
                  width: '100%', boxSizing: 'border-box',
                  padding: '9px 12px', fontSize: 13,
                  border: '0.5px solid rgba(0,0,0,0.2)', borderRadius: 8,
                  outline: 'none', background: '#fafaf9',
                }}
              />
            </div>

            <div style={{ marginBottom: '1.5rem' }}>
              <label style={{ fontSize: 12, fontWeight: 600, color: '#555', display: 'block', marginBottom: 5 }}>
                Password
              </label>
              <input
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="••••••••"
                required
                style={{
                  width: '100%', boxSizing: 'border-box',
                  padding: '9px 12px', fontSize: 13,
                  border: '0.5px solid rgba(0,0,0,0.2)', borderRadius: 8,
                  outline: 'none', background: '#fafaf9',
                }}
              />
            </div>

            {error && (
              <div style={{
                background: '#FCEBEB', color: '#A32D2D', borderRadius: 8,
                padding: '9px 12px', fontSize: 12, marginBottom: '1rem',
              }}>
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              style={{
                width: '100%', padding: '10px', fontSize: 14, fontWeight: 600,
                background: loading ? '#93b8d9' : '#185FA5', color: '#fff',
                border: 'none', borderRadius: 8, cursor: loading ? 'default' : 'pointer',
              }}
            >
              {loading ? 'Masuk...' : 'Masuk'}
            </button>
          </form>
        </div>

        <div style={{ textAlign: 'center', fontSize: 11, color: '#bbb', marginTop: '1.5rem' }}>
          Hubungi admin jika lupa password
        </div>
      </div>
    </div>
  )
}
